import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  mainGrid: {
    padding: "0px",
    margin: "0px",
    minHeight: "calc(100vh - 120px)",
    "@media (max-width: 767.98px)": {
      minHeight: "auto",
    },
  },
  sideStyle: {
    borderRightWidth: "20px",
    borderRightStyle: "solid",
    borderImage: "linear-gradient(#2156a4, #32a6c4e3) 30"
  },

  //right div styles

  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "2px solid #76787a",
    paddingBottom: "10px",
    margin: "10px 0px 10px 0px",
    color: "black",
    fontSize: "18px",
  },
  profile: {
    height: "80px",
    width: "80px",
    borderRadius: "20%",
    //objectFit: "contain",
    //border: "1px solid gray",
  },
  buttonStyle: {
    border: "none",
    fontSize: "14px",
    color: "#28292a",
    //borderRadius: "15px",
  },
  name: {
    fontSize: "16px",
    marginBottom: "5px",
    color: "#76787a",
    marginTop: "4px",
    float: "left",
  },
  role: {
    fontSize: "14px",
    color: "#76787a",
  },
  labels: {
    fontSize: "12px",
    color: "#76787a",
    marginLeft: "3%",
    textTransform: "uppercase"
  },
  valueLabels: {
    fontSize: "13px",
    marginLeft: "0.8em",
  },
  profileDiv: {
    minHeight: "10px !important",
    maxHeight: "40px !important",
  },
  updateButtonStyles: {
    borderRadius: "20px",
    //fontSize: "10px",
    textTransform: "capitalize",
    //marginTop: "1em"
  },
  imageiconsMenu: {
    width: "30px",
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    //marginTop: "2px",
  },

  // Modal- Styles

  title: {
    color: "#76787a",
    fontSize: "22px",
    fontWeight: "500"
  },
  headerStyle: {
    //background: "#0d6cbf",
    height: "50px",
  },
  footerStyle: {
    display: "block !important",
    textAlign: "center",
    borderTop: "none",
  },
  modalLabels: {
    color: "#76787a",
  },

});

export default styles;
